module.exports = __webpack_public_path__ + "img/bg.20694e79.png";